import { createContext } from 'react'

const licensingContext = createContext()

export default licensingContext
